import { Action, Alert } from 'corso-admin-ui';
import { ComponentProps } from 'react';
import { To } from 'react-router-dom';

/** Sends the merchant to the settings page that has to be configured first, with a right-aligned View action. */
export function ConfigurationAlert({
  message,
  to,
  ...alert
}: Omit<ComponentProps<typeof Alert>, 'children'> & {
  message: string;
  to: To;
}) {
  return (
    // oxlint-disable-next-line react/jsx-props-no-spreading
    <Alert {...alert}>
      <div className="flex items-center justify-between gap-2">
        <p>{message}</p>
        <Action to={to}>View</Action>
      </div>
    </Alert>
  );
}
